import { mapState, mapGetters, mapActions } from 'vuex';

const NotificationDataProvider = {
  data() {
    return {
      activeFilter: 'all',
      isActive: false,
      filteredItemsList: [],
    };
  },

  computed: {
    ...mapState('user', {
      loggedIn: (state) => state.loggedIn,
    }),
    ...mapGetters('savedItems', {
      getItems: 'getItems',
      getItemsByType: 'getItemsByType',
      getItemCount: 'getItemCount',
    }),
    getSavedJobs() {
      return this.getItemsByType({
        type: 'jobs',
        expired: false,
        registerInterest: false,
      });
    },
    getAllSaveItems() {
      return this.getItems.filter((item) => item.type !== 'connect-shared');
    },
    getSavedReviews() {
      return this.getItemsByType({ type: 'reviews' }).filter((item) => item.type !== 'connect-shared');
    },
    getSavedCompanies() {
      return this.getItemsByType({ type: 'companies' }).filter((item) => item.type !== 'connect-shared');
    },

    getSavedRegisterInterestJobs() {
      return this.getItemsByType({
        type: 'jobs',
        expired: false,
        registerInterest: true,
      });
    },

    totalCount() {
      return this.getAllSaveItems.length;
    },

    jobsCount() {
      return this.getSavedJobs.length;
    },

    reviewsCount() {
      return this.getSavedReviews.length;
    },

    companiesCount() {
      return this.getSavedCompanies.length;
    },

    registerInterestCount() {
      return this.getSavedRegisterInterestJobs.length;
    },
    unReadNotificationsCount() {
      const unReadItems = this.getAllSaveItems.filter((item) => item.read_status === 0);
      if (this.loggedIn) {
        if (unReadItems.length > 99) {
          return '99+';
        }
        return unReadItems.length;
      }
      return false;
    },
    filteredItems() {
      switch (this.activeFilter) {
        case 'jobs':
          return this.filterItemsToDisplay(this.getSavedJobs);
        case 'companies':
          return this.filterItemsToDisplay(this.getSavedCompanies);
        case 'reviews':
          return this.filterItemsToDisplay(this.getSavedReviews);
        case 'register-interest':
          return this.filterItemsToDisplay(this.getSavedRegisterInterestJobs);
        case 'All':
          return this.filterItemsToDisplay(this.getAllSaveItems.filter((item) => item.type !== 'connect-shared'));
        default:
          return this.filterItemsToDisplay(this.getAllSaveItems.filter((item) => item.type !== 'connect-shared'));
      }
    },
    noSavedItemFallBlack() {
      switch (this.activeFilter) {
        case 'jobs':
          return { template: 'NotificationNoJobItem', showFallBack: this.jobsCount <= 0 };
        case 'companies':
          return { template: 'NotificationNoCompanyItem', showFallBack: this.companiesCount <= 0 };
        case 'reviews':
          return { template: 'NotificationNoReviewItem', showFallBack: this.reviewsCount <= 0 };
        case 'register-interest':
          return { template: 'NotificationNoRegisterInterestItem', showFallBack: this.registerInterestCount <= 0 };
        case 'All':
          return { template: 'NoNotifications', showFallBack: this.totalCount <= 0 && this.loggedIn };
        default:
          return { template: 'NoNotifications', showFallBack: this.totalCount <= 0 && this.loggedIn };
      }
    },
  },

  methods: {
    ...mapActions('notifications', {
      updateReadStatus: 'updateReadStatus',
    }),
    closeNotifications() {
      this.isActive = false;
      window.gtag.send({ event: 'side-panel', action: 'close-panel' });
      document.body.setAttribute('style', 'overflow:auto');
    },
    openNotification() {
      this.$gtag.send({ event: 'side-panel', action: 'open-panel' });
      this.isActive = !this.isActive;
      this.activeFilter = 'all';
      document.body.setAttribute('style', 'overflow:hidden');
      if (this.loggedIn) { this.updateNotificationCounts(); }
    },
    filterItemsToDisplay(items) {
      return items.slice(0, 20).map((item) => {
        return item;
      });
    },
    updateNotificationCounts() {
      if (this.unReadNotificationsCount === 0) { return; }
      const unReadSavedReviews = this.returnItemsIDs(this.getSavedReviews.filter((item) => item.read_status === 0));
      const unReadSavedJobs = this.returnItemsIDs(this.getItemsByType({
        type: 'jobs',
        expired: false,
      }).filter((item) => item.read_status === 0));
      const unReadSavedCompanies = this.returnItemsIDs(this.getSavedCompanies.filter((item) => item.read_status === 0));

      const payLoad = { jobs: unReadSavedJobs, companies: unReadSavedCompanies, reviews: unReadSavedReviews };

      this.updateReadStatus(payLoad);
    },
    returnItemsIDs(items) {
      return items.length > 0 ? items.map((item) => item.id) : false;
    },
    changeFilter(filterItem) {
      this.activeFilter = filterItem;
      window.gtag.send({
        event: 'side-panel',
        action: `change-filter-${filterItem.toLowerCase()}`,
      });
      document.querySelector('.Notification-content').scrollTop = 0;
    },
  },

  created() {
    this.$bus.$on('bus:notifications:close', () => {
      this.closeNotifications();
    });
  },
  mounted() {
    document.addEventListener('keyup', (e) => {
      if (this.isActive && e.keyCode === 27) {
        this.closeNotifications();
      }
    });
  },
  render() {
    return this.$slots.default({
      props: {
        filteredItemsList: this.filteredItemsList,
        filteredItems: this.filteredItems,
        loggedIn: this.loggedIn,
        counts: {
          registerInterestCount: this.registerInterestCount,
          companiesCount: this.companiesCount,
          totalCount: this.totalCount,
          reviewsCount: this.reviewsCount,
          jobsCount: this.jobsCount,
          unReadNotificationsCount: this.unReadNotificationsCount,
        },
        ui: {
          isActive: this.isActive,
          activeFilter: this.activeFilter,
          noSavedItemFallBlack: this.noSavedItemFallBlack,
        },
      },
      listeners: {
        changeFilter: this.changeFilter,
        openNotification: this.openNotification,
        closeNotifications: this.closeNotifications,
      },
    });
  },
};

export default NotificationDataProvider;
